import React from 'react';
import classnames from 'classnames';
import './DayInitialiser.scss';

const convertPositionToTime = position => {
  // Assumes known height of 1440px
  let hour = (position - (position % 60)) / 60;
  let mins = position - hour * 60;
  let postfix = hour > 11 ? 'pm' : 'am';

  if (hour === 0) {
    hour = 12;
  }

  if (hour > 12) {
    hour = hour - 12;
  }

  return `${hour}:${('0' + mins).slice(-2)}${postfix}`;
};

class DayInitialiser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDragging: false,
      drawObjectHeight: null,
      drawObjectStartY: null,
      maxDrawLength: null, // How tall it can become before colliding
      editDrag: null,
      initialDragStart: null,
      editDragClickPosition: null,
      initialEntryPositionOffset: null,
      actionPerformed: false, // Was an entry clicked
      resizeDrag: null,
      hoverHeight: null, //
    };

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.findMaxLength = this.findMaxLength.bind(this);
    this.handleChangePropogation = this.handleChangePropogation.bind(this);
    this.handleHoverOff = this.handleHoverOff.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.handleUpdate.length > 0) {
      const handleUpdateIDs = nextProps.handleUpdate.map(x => x.id);
      const currentIDs = this.props.existingData.map(x => x.id);
      let newIndexs = [...handleUpdateIDs]; // Webpack bug fix

      const hasCollided = testEntry =>
        this.props.existingData.every(checkEntry => {
          // Check no collisions with other entries
          if (checkEntry.id === testEntry.id) {
            return true;
          }

          return this.doEntriesCollide(testEntry, checkEntry) === false;
        });

      const returnValues = [
        ...this.props.existingData.map((entry, index) => {
          const findDeleteIndex = newIndexs.findIndex(x => x === entry.id);

          if (findDeleteIndex !== undefined) {
            newIndexs[findDeleteIndex] = null;
          }

          if (handleUpdateIDs.includes(entry.id)) {
            const newValue = nextProps.handleUpdate.find(
              x => x.id === entry.id,
            );
            if (hasCollided(newValue)) {
              return newValue;
            }
          }
          return entry;
        }),
        ...nextProps.handleUpdate.filter((entry, index) => {
          if (currentIDs.includes(entry.id) === false) {
            if (hasCollided(entry)) {
              return true;
            }
          }
          return false;
        }),
      ];

      this.handleChangePropogation(returnValues);
    }
  }

  getHeightFromTop(element) {
    let yPosition = 0;

    while (element) {
      yPosition += element.offsetTop + element.clientTop;
      element = element.offsetParent;
    }

    return yPosition;
  }

  round(number, closest) {
    return Math.round(number / closest) * closest;
  }

  getEventYOffset(event) {
    return event.pageY - this.getHeightFromTop(this.parentDiv);
  }

  doEntriesCollide(EntryOne, EntryTwo) {
    // return if any two entries overlap
    const EntryOne__Finish = EntryOne.start + EntryOne.height;
    const EntryTwo__Finish = EntryTwo.start + EntryTwo.height;

    if (EntryOne.isNegative === true || EntryTwo.isNegative === true) {
      // Negative times do not collide
      return false;
    }

    if (
      EntryOne__Finish < EntryTwo__Finish &&
      EntryOne__Finish > EntryTwo.start
    ) {
      return true;
    }

    if (
      EntryTwo__Finish < EntryOne__Finish &&
      EntryTwo__Finish > EntryOne.start
    ) {
      return true;
    }

    if (EntryOne.start < EntryTwo__Finish && EntryOne.start > EntryTwo.start) {
      return true;
    }

    if (EntryTwo.start < EntryOne__Finish && EntryTwo.start > EntryOne.start) {
      return true;
    }

    return false;
  }

  findMaxLength(Start) {
    return this.props.existingData.reduce((sum, value) => {
      const newValue = value.start - Start;

      if (newValue < 0) {
        return sum;
      }

      if (sum === null) {
        return newValue;
      }

      if (sum > newValue) {
        return newValue;
      }

      return sum;
    }, null);
  }

  // **** Create Entry **** //
  handleMouseDown(event) {
    if (this.hasDayPassed(true) === false) {
      if (this.state.isDragging === false) {
        const newStart = this.round(this.getEventYOffset(event), 15);

        let startTimestamp = new Date();
        startTimestamp.setDate(
          startTimestamp.getDate() +
            this.props.day -
            ((startTimestamp.getDay() + 6) % 7),
        );
        startTimestamp.setHours(0, 0, 0, 0);

        if (startTimestamp.getTime() < Date.now()) {
          // Can't create in past
          if ((Date.now() - startTimestamp.getTime()) / 60000 > newStart) {
            return;
          }
        }

        if (
          this.props.existingData.every(entry => {
            return (
              this.doEntriesCollide(entry, {
                start: newStart,
                height: 30,
              }) === false
            );
          })
        ) {
          const MaxDraw = this.findMaxLength(newStart);
          this.setState({
            hoverHeight: null,
            isDragging: true,
            drawObjectStartY: newStart,
            maxDrawLength: MaxDraw,
          });
        }
      }
    }
  }

  onMouseMove(event) {
    if (this.hasDayPassed(true) === false) {
      if (this.state.editDrag !== null) {
        // Edit position
        const clickPosition = this.getEventYOffset(event);
        let changeCaused = false;

        let Entries = this.props.existingData.map(entry => {
          if (entry.id === this.state.editDrag) {
            let mutationEntry = Object.assign({}, entry, {
              start:
                this.state.initialEntryPositionOffset -
                this.round(
                  this.state.editDragClickPosition - clickPosition,
                  15,
                ),
            });

            if (mutationEntry.start !== entry.start) {
              changeCaused = true;
              const hasCollided = this.props.existingData.every(checkEntry => {
                // Check no collisions with other entries
                if (checkEntry.id === this.state.editDrag) {
                  return true;
                }

                return (
                  this.doEntriesCollide(mutationEntry, checkEntry) === false
                );
              });

              if (
                mutationEntry.start >= 0 &&
                mutationEntry.start + mutationEntry.height <= 1440
              ) {
                if (hasCollided) {
                  return mutationEntry;
                }
              }
            }
          }
          return entry;
        });

        if (changeCaused) {
          this.setState({
            actionPerformed: true,
          });
          this.handleChangePropogation(Entries, false);
        }
      } else if (this.state.resizeDrag) {
        // Resizing
        const newHeight = this.round(
          event.pageY - this.getHeightFromTop(this.parentDiv),
          15,
        );

        let Entries = this.props.existingData.map(entry => {
          if (entry.id === this.state.resizeDrag) {
            let mutationEntry = Object.assign({}, entry, {
              height:
                this.state.initialEntryPositionOffset -
                (this.state.initialResizeDragStart - newHeight),
            });

            const hasCollided = this.props.existingData.every(checkEntry => {
              // Check no collisions with other entries
              if (checkEntry.id === this.state.resizeDrag) {
                return true;
              }

              return this.doEntriesCollide(mutationEntry, checkEntry) === false;
            });

            if (
              mutationEntry.height >= 30 &&
              mutationEntry.start >= 0 &&
              mutationEntry.start + mutationEntry.height <= 1440
            ) {
              if (hasCollided) {
                return mutationEntry;
              }
            }
          }
          return entry;
        });

        this.handleChangePropogation(Entries, false);
        this.setState({
          actionPerformed: true,
        });
      } else if (this.state.isDragging) {
        // Creating
        const newHeight = this.round(
          this.getEventYOffset(event) - this.state.drawObjectStartY,
          15,
        );
        if (this.getEventYOffset(event) > this.state.drawObjectStartY) {
          // No negative time meetings
          if (
            Math.abs(
              this.state.drawObjectStartY - this.getEventYOffset(event),
            ) > 5
          ) {
            if (
              newHeight <= this.state.maxDrawLength ||
              this.state.maxDrawLength === null
            ) {
              this.setState({
                drawObjectHeight: newHeight,
                actionPerformed: true,
              });
            } else {
              this.setState({
                drawObjectHeight: this.state.maxDrawLength,
              });
            }
          }
        }
      } else {
        // Hover effect
        if (
          event.target.className === 'DayInitialiser' ||
          event.target.className === 'DayInitialiser__HoverEffect'
        ) {
          const eventPosition = this.round(this.getEventYOffset(event), 15);
          this.setState({
            hoverHeight: eventPosition,
          });
        } else {
          this.setState({
            hoverHeight: null,
          });
        }
      }
    }
  }

  handleMouseUp(event) {
    // Most likely a new entry was created
    if (this.hasDayPassed(true) === false) {
      const newStart = this.round(this.getEventYOffset(event), 15);

      let startTimestamp = new Date();
      startTimestamp.setDate(
        startTimestamp.getDate() +
          this.props.day -
          ((startTimestamp.getDay() + 6) % 7),
      );
      startTimestamp.setHours(0, 0, 0, 0);

      if (startTimestamp.getTime() < Date.now()) {
        // Can't create in past
        if ((Date.now() - startTimestamp.getTime()) / 60000 > newStart) {
          return;
        }
      }

      const newObject = {
        id:
          new Date().getSeconds().toString() +
          new Date().getUTCMilliseconds().toString(),
        start: this.state.drawObjectStartY,
        height: this.state.drawObjectHeight,
      };

      if (newObject.height >= 30) {
        const newValues = [...this.props.existingData, newObject];

        this.handleChangePropogation(newValues);
      }

      if (this.state.resizeDrag !== null) {
        this.handleChangePropogation();
      }

      if (this.state.actionPerformed === false) {
        if (
          event.target.className !== 'DayInitialiser__DayEntry' &&
          event.target.className !== 'DayInitialiser__DragWrapper'
        ) {
          this.props.displayModal({
            start: this.round(this.getEventYOffset(event), 15),
            height: 30,
            day: this.props.day,
          });
        }
      }

      this.setState({
        // Reset the state
        isDragging: false,
        drawObjectHeight: null,
        drawObjectStartY: null,
        editDrag: null,
        editDragClickPosition: null,
        initialEntryPositionOffset: null,
        resizeDrag: null,
        resizeDragStarting: null,
        initialResizeDragStart: null,
        actionPerformed: false,
      });
    }
  }

  // **** Move Entry **** //
  startDrag(id) {
    // Click and Drag to relocate entry start
    return event => {
      if (this.hasDayPassed() === false) {
        const clickPosition = this.getEventYOffset(event);

        this.setState({
          hoverHeight: null,
          editDrag: id,
          editDragClickPosition: clickPosition,
          initialEntryPositionOffset: this.props.existingData.filter(
            x => x.id === id,
          )[0].start,
          actionPerformed: false,
        });
      }
    };
  }

  // **** Open Modal **** //
  handleOnEntryClick(id) {
    return event => {
      console.log('Clicked');
      if (this.hasDayPassed() === false) {
        if (this.state.actionPerformed === false) {
          if (this.props.displayModal) {
            this.props.displayModal(id);
          }
        } else {
          this.setState({
            actionPerformed: false,
          });
        }
      }
    };
  }

  // **** Resize **** //
  handleResizeDragStart(id) {
    return event => {
      if (this.hasDayPassed() === false) {
        const startingHeight = this.round(this.getEventYOffset(event), 15);

        this.setState({
          hoverHeight: null,
          resizeDrag: id,
          resizeDragStarting: startingHeight,
          initialResizeDragStart: this.props.existingData.filter(
            x => x.id === id,
          )[0].start,
        });
      }
    };
  }

  renderInProgress() {
    // Render the entry that is currently being drawn
    if (
      this.state.drawObjectStartY !== undefined &&
      this.state.drawObjectHeight !== undefined
    ) {
      return (
        <div
          className="DayInitialiser__WIPDayEntry"
          style={{
            height: this.state.drawObjectHeight,
            top: this.state.drawObjectStartY,
          }}
        >
          {convertPositionToTime(this.state.drawObjectStartY) +
            ' - ' +
            convertPositionToTime(
              this.state.drawObjectStartY + this.state.drawObjectHeight,
            )}
        </div>
      );
    }
  }

  renderHoverEffect() {
    if (this.state.hoverHeight !== null) {
      if (
        this.props.existingData.every(checkEntry => {
          // Check no collisions with other entries
          return (
            this.doEntriesCollide(
              {
                start: this.state.hoverHeight,
                height: 20,
              },
              checkEntry,
            ) === false
          );
        })
      ) {
        return (
          <div
            className="DayInitialiser__HoverEffect"
            style={{
              height: 20,
              top: this.state.hoverHeight,
            }}
          >
            +
          </div>
        );
      }
    }
  }

  handleChangePropogation(newValue, shouldSave = true) {
    if (this.props.onChange) {
      this.props.onChange(newValue || this.props.existingData, shouldSave);
    }
  }

  handleMoveSave() {
    if (this.state.actionPerformed === true) {
      this.handleChangePropogation();
    }
  }

  handleHoverOff() {
    this.setState({
      hoverHeight: null,
    });
  }

  hasDayPassed(IncludeCurrentDay = false) {
    let startTimestamp = new Date();
    startTimestamp.setDate(
      startTimestamp.getDate() +
        this.props.day -
        ((startTimestamp.getDay() + 6) % 7),
    );
    startTimestamp.setHours(0, 0, 0, 0);
    const DayInclusive = IncludeCurrentDay === false ? 86400000 : 0;

    return startTimestamp.getTime() + DayInclusive < Date.now();
  }

  handleGreyOut() {
    let startTimestamp = new Date();
    startTimestamp.setDate(
      startTimestamp.getDate() +
        this.props.day -
        ((startTimestamp.getDay() + 6) % 7),
    );
    startTimestamp.setHours(0, 0, 0, 0);

    if (startTimestamp.getTime() < Date.now()) {
      let Styles = {};
      if (startTimestamp.getTime() + 86400000 > Date.now()) {
        Styles['height'] =
          (Date.now() - startTimestamp.getTime()) / 864000 + '%';
      }

      return <div className="DayIntialiser__GreyOut" style={Styles} />;
    }

    return null;
  }

  render() {
    let DayStartTimestamp = new Date();
    let DayEndTimestamp = new Date();

    DayStartTimestamp.setDate(
      DayStartTimestamp.getDate() +
        this.props.day -
        ((DayStartTimestamp.getDay() + 6) % 7),
    );
    DayEndTimestamp.setDate(
      DayStartTimestamp.getDate() +
        this.props.day -
        ((DayStartTimestamp.getDay() + 6) % 7),
    );

    DayStartTimestamp.setHours(0, 0, 0, 0);
    DayEndTimestamp.setHours(23, 49, 59, 999);

    const IsCurrentDay =
      DayStartTimestamp.getTime() < Date.now() &&
      DayEndTimestamp.getTime() > Date.now();
    let conditialParameters = {};

    if (IsCurrentDay) {
      conditialParameters = {
        ...conditialParameters,
        onClick: this.props.showErrorModal,
      };
    }

    return (
      <div
        ref={input => {
          this.parentDiv = input;
        }}
        onMouseMove={this.onMouseMove.bind(this)}
        onMouseLeave={this.handleHoverOff}
        className={classnames({
          DayInitialiser: true,
          'DayInitialiser--UnCountedDay':
            DayStartTimestamp.getTime() < Date.now(),
          'DayInitialiser--CurrentDay': IsCurrentDay,
        })}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        {...conditialParameters}
      >
        {this.handleGreyOut()}
        {this.state.isDragging ? this.renderInProgress() : null}
        {this.state.hoverHeight !== null ? this.renderHoverEffect() : null}
        {this.props.existingData.map((entry, index) => {
          return (
            <div
              key={entry.id}
              className={classnames({
                DayInitialiser__DayEntry: true,
                'DayInitialiser__DayEntry--negative': entry.isNegative === true,
              })}
              style={{
                height: entry.height,
                top: entry.start,
              }}
              onMouseUp={this.handleMoveSave.bind(this)}
            >
              {entry.isNegative !== true ? (
                <div
                  className="DayInitialiser__DragWrapper"
                  onMouseDown={this.startDrag(entry.id).bind(this)}
                  onMouseUp={this.handleMoveSave.bind(this)}
                  onMouseUp={this.handleOnEntryClick(entry.id).bind(this)}
                >
                  {convertPositionToTime(entry.start) +
                    ' - ' +
                    convertPositionToTime(entry.start + entry.height)}
                </div>
              ) : (
                // Display if Negative
                <div className="DayInitialiser__DragWrapper">
                  {convertPositionToTime(entry.start) +
                    ' - ' +
                    convertPositionToTime(entry.start + entry.height)}
                  {entry.module_instance !== null ? (
                    <p style={{ fontSize: '10px' }}>
                      {entry.module_instance.module.module_name} -{' '}
                      {entry.module_instance.student.first_name}
                    </p>
                  ) : null}
                </div>
              )}
              {entry.isNegative !== true ? (
                <div
                  className="DayInitialiser__DayEntry--resize"
                  onMouseDown={this.handleResizeDragStart(entry.id).bind(this)}
                />
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}

export default DayInitialiser;



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/ViewScheduler/components/DayInitialiser/index.js